<style lang="scss"></style>

<template>
  <div style="overflow: auto;height: 100%;position: relative;">
    <div class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 14px;">
      <span style="width: 5px;height: 16px;background:  rgba(198, 22, 75, 1);margin-right:12px ;"></span>
      <p style="font-size: 13px;color: #F4F4F4;">
        {{ $t('呆滞预警(超过7日未卸车)') }}
      </p>
    </div>
    <div class="alerts" style="padding: 20px;">
      <div class="alert" style="margin-bottom: 26px;display: flex;justify-content: space-between;" v-for="alert in alerts">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <p style="font-size: 16px;color: #FFF;">
            {{ alert }}
          </p>

        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 8px;">
          <div :style="{ background: '#C6164B' }" style="font-size:10px;color: #F4F4F4;border-radius:12px ;padding: 2px 8px;display: flex;justify-content: center;align-items: center;flex-shrink: 0;">
            {{ $t('未卸车') }}
          </div>

        </div>
      </div>
    </div>
    <div class="bottomBar" style="width: 100%;height: 20px;position: sticky;bottom: 0;background: #202027;"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_alert',
  components: {},

  data() {
    return {
      timmer: null,
      alerts: [],
    };
  },
  created() {
    this.timmer = setInterval(() => {
      this.listAlarm();
    }, 120000);
    this.listAlarm();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });

  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listAlarm();
    }
  },
  destroyed() {
    this.utils.event_hub.$off('SetCard');
    clearInterval(this.timmer);
  },
  methods: {


    async listAlarm() {
      let response = await this.http.get('web/slag/collection/record/getStagnantWarning', {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      this.alerts = response.data;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 800);
    }
  }
};
</script>
